import { ReactNode } from "react";

interface PhoneFrameProps {
  children: ReactNode;
  scale?: number;
  className?: string;
}

const PhoneFrame = ({ children, scale = 1, className = "" }: PhoneFrameProps) => {
  return (
    <div
      className={`relative ${className}`}
      style={{ width: 360 * scale, height: 720 * scale }}
    >
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          width: 360,
          height: 720,
          borderRadius: 54,
          overflow: "hidden",
          background: "#000",
          padding: 8,
          boxShadow: "0 50px 100px -20px rgba(0,0,0,0.5), 0 30px 60px -30px rgba(0,0,0,0.4)",
          position: "relative",
        }}
      >
        <div style={{ position: "absolute", top: 12, left: "50%", transform: "translateX(-50%)", width: 120, height: 32, borderRadius: 999, background: "#000", zIndex: 20 }} />
        <div style={{ position: "absolute", top: 18, left: 28, zIndex: 21, fontFamily: "Geist, sans-serif", fontSize: 15, fontWeight: 600, letterSpacing: -0.2, mixBlendMode: "difference", color: "white" }}>9:41</div>
        <div style={{ position: "absolute", top: 22, right: 28, zIndex: 21, color: "white", mixBlendMode: "difference", fontSize: 14, letterSpacing: 1 }}>•••</div>
        <div style={{ position: "absolute", bottom: 14, left: "50%", transform: "translateX(-50%)", width: 134, height: 5, borderRadius: 3, background: "rgba(255,255,255,0.9)", zIndex: 20 }} />
        <div className="phone-screen" style={{ width: "100%", height: "100%", borderRadius: 46, overflow: "hidden", position: "relative" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PhoneFrame;
